import { render, staticRenderFns } from "./PayrollPeriodAddEditModal.vue?vue&type=template&id=4ebd3363"
import script from "./PayrollPeriodAddEditModal.vue?vue&type=script&lang=js"
export * from "./PayrollPeriodAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports